/* epgCardTitle.tsx */
import Colors from '@shared/assets/style/default/color';
import Fonts from '@shared/assets/style/default/fonts';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

const EpgCardTitle = styled.div<{
  displayContent: boolean;
  unavailable?: boolean;
}>`
  color: ${(props) =>
    props.unavailable ? 'rgba(255, 255, 255, 0.50)' : Colors['text']};
  font-family: ${Fonts['regular']};
  font-size: ${32 * Screen.widthRatio}px;
  overflow: hidden;
  position: relative;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: ${(props) => (props.displayContent ? 'unset' : 'center')};
  width: ${(props) => (props.displayContent ? 'unset' : '100%')};
`;

export default EpgCardTitle;
